import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

import {rootStore} from "./stores/RootStore";
import ScrollHelper from "./utils/ScrollHelper";
import firebase from "firebase";

new ScrollHelper(rootStore);

ReactDOM.render(<App store={rootStore}/>, document.getElementById('root'));

const setSizes = () => {
    rootStore.interactionsStore.setClientSize(document.documentElement.clientWidth, document.documentElement.clientHeight);
};
window.addEventListener('resize', function (e) {
    setSizes();
});
window.addEventListener('scroll', function (e) {
    rootStore.interactionsStore.setTooltipIndex(-1);//prevent highlighted elements from sticking on mobile
});
setSizes();
const handleAnonymousSignIn = (store) => {
    const {persistStore} = store;
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.NONE).then(() => {
        firebase.auth().signInAnonymously().then((response) => {
            if (response.user && response.user.uid) {
                persistStore.setUserId(response.user.uid);
                store.getFbModel().saveOrUpdate();
            } else {
                console.log('no user id found..');
            }
        }).catch((error) => {
            if (error) {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log('Error: handleAnonymousSignIn: ' + errorMessage);
            }
        });
    });
};
handleAnonymousSignIn(rootStore);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
